import React, { FunctionComponent, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle, faSearch } from "@fortawesome/free-solid-svg-icons";
import SchoolsTable from "./SchoolsTable";
import { ApplicationState } from "../../../../../store";
import { bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";
import { UserInfo } from "../../../../../store/auth/types";
import {
  getSchools,
  openUpsertSchoolModal,
  schoolSearchFilter,
} from "../../../../../store/onboarding/actions";
import { Form, InputGroup, OverlayTrigger, Tooltip } from "react-bootstrap";

type StateProps = {
  userInfo?: UserInfo;
  searchFilter?: string;
};

type DispatchProps = {
  openUpsertSchoolModal: () => any;
  getSchools: () => any;
  schoolSearchFilter: (searchFilter?: string) => any;
};

type Props = StateProps & DispatchProps;

const SchoolsManagementTab: FunctionComponent<Props> = ({
  userInfo,
  searchFilter,
  openUpsertSchoolModal,
  getSchools,
  schoolSearchFilter,
}) => {
  useEffect(() => {
    getSchools();
  }, []);

  const handleSearchFilterChange = (event: React.FormEvent<any>) => {
    event.preventDefault();
    const { value } = event.target as HTMLInputElement;
    schoolSearchFilter(value);
  };

  return (
    <div className="manageDistrictContainer">
        <h2 className="font-weight-bold mb-2">Manage Schools</h2>
        <h4 className="mb-4">The Manage Schools page allows administrators to view, add, and update school information within the district, ensuring that all school records remain accurate and organized.</h4>
        <div className="d-flex justify-content-between align-items-end mt-2">
          <InputGroup className="filterSearchDesktop mr-2" style={{width:"300px"}}>
            <InputGroup.Prepend>
              <InputGroup.Text>
                <FontAwesomeIcon icon={faSearch} />
              </InputGroup.Text>
            </InputGroup.Prepend>
            <Form.Control
              type="text"
              placeholder="Search"
              value={searchFilter as any}
              onChange={handleSearchFilterChange}
              className="filterSearchHeight"
            />
          </InputGroup>
          <OverlayTrigger
            overlay={
              <Tooltip id="remove-data-permissions-btn" className="customInfoTooltip">
                Add New School
              </Tooltip>
            }
          >
            <button
              className="blueBtnSm withInnerWhiteSvg"
              onClick={() => openUpsertSchoolModal()}
            >
              <FontAwesomeIcon icon={faPlusCircle} /> 
              school
            </button>
          </OverlayTrigger>
        </div>
      <hr/>
      <SchoolsTable />
    </div>
  );
};

const mapStateToProps = ({ auth }: ApplicationState): StateProps => {
  return {
    userInfo: auth.userInfo,
  };
};

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps =>
  bindActionCreators(
    {
      openUpsertSchoolModal: openUpsertSchoolModal,
      getSchools: getSchools,
      schoolSearchFilter: schoolSearchFilter
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SchoolsManagementTab);
